import config from '../../../../config/config';
import REST_API_NAMES from '../../../../config/restApiNames';
import moment from 'moment-timezone';
import Enum from '../../../../util/EnumUtil';
import SafeConsole from '../../../../util/ConsoleUtils';

const ActionTypes = Enum.set('FETCHING', 'FETCH_SUCCESS');

const BUSINESS_HOUR = {
  ADT: {
    weekday: { start: 9, for: 15 },
    weekend: { start: 11, for: 11 },
  },
  AST: {
    weekday: { start: 9, for: 15 },
    weekend: { start: 11, for: 11 },
  },
  EDT: {
    weekday: { start: 8, for: 15 },
    weekend: { start: 10, for: 11 },
  },
  EST: {
    weekday: { start: 8, for: 15 },
    weekend: { start: 10, for: 11 },
  },
  CDT: {
    weekday: { start: 7, for: 15 },
    weekend: { start: 9, for: 11 },
  },
  CST: {
    weekday: { start: 7, for: 15 },
    weekend: { start: 9, for: 11 },
  },
  MDT: {
    weekday: { start: 6, for: 15 },
    weekend: { start: 8, for: 11 },
  },
  MST: {
    weekday: { start: 6, for: 15 },
    weekend: { start: 8, for: 11 },
  },
  PDT: {
    weekday: { start: 5, for: 15 },
    weekend: { start: 7, for: 11 },
  },
  PST: {
    weekday: { start: 5, for: 15 },
    weekend: { start: 7, for: 11 },
  },
  AKDT: {
    weekday: { start: 4, for: 15 },
    weekend: { start: 6, for: 11 },
  },
  AKST: {
    weekday: { start: 4, for: 15 },
    weekend: { start: 6, for: 11 },
  },
  HST: {
    weekday: { start: 3, for: 15 },
    weekend: { start: 5, for: 11 },
  },
};

const VHT_NUMBER_OF_DAYS = 7,
  LOCAL_NUMBER_OF_DAYS = 2;

const getAvailableTimeslots = (segment, from, zoneId) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.FETCHING,
    });
    _fetchNextAppointmentTimeFromVHT(segment, from)
      .then((timeslots) => {
        dispatch({
          type: ActionTypes.FETCH_SUCCESS,
          data: filterTimeslots(timeslots, zoneId, VHT_NUMBER_OF_DAYS),
        });
      })
      .catch((err) => {
        // TODO: how to put in 15 minute buffer??
        SafeConsole.log(err);
        dispatch({
          type: ActionTypes.FETCH_SUCCESS,
          data: filterTimeslots(generateLocalTimeslots(from, zoneId), zoneId, LOCAL_NUMBER_OF_DAYS),
        });
      });
  };
};

const filterTimeslots = (slots, zoneId, numberOfDays) => {
  var availableTimeSlots = {},
    finalTimeslots = [],
    now = moment().tz(zoneId),
    start = null,
    cutOff = null,
    count = 0;

  // group the raw slots by date
  for (let i = 0; i < slots.length; i++) {
    let time = slots[i],
      dt = moment(time).tz(zoneId),
      formatted = dt.format('YYYY-MM-DD');

    if (!availableTimeSlots[formatted]) {
      let z = dt.format('z'),
        businessHour = BUSINESS_HOUR[z].weekday;
      if (/(Sat|Sun)/.test(dt.format('ddd'))) {
        businessHour = BUSINESS_HOUR[z].weekend;
      }

      if (numberOfDays <= count) {
        // number of days buffer reached
        break;
      }

      start = moment(dt.valueOf())
        .tz(zoneId)
        .hour(businessHour.start)
        .minute(0)
        .second(0)
        .millisecond(0)
        .valueOf();
      cutOff = moment(dt.valueOf())
        .tz(zoneId)
        .hour(businessHour.start + businessHour.for)
        .minute(0)
        .second(0)
        .millisecond(0)
        .valueOf();

      //get today's cutoff and dt should be no more than cutoff
      var todayCutOff = now
        .hour(businessHour.start + businessHour.for)
        .minute(0)
        .second(0)
        .millisecond(0)
        .valueOf();
      if (
        formatted === now.format('YYYY-MM-DD') && //is today
        dt.valueOf() < now.valueOf() &&
        dt.valueOf() >= todayCutOff
      ) {
        continue;
      }

      // total of days inside the list
      count++;

      // need to determine business start and cutoff time to cross check with vht returned time
      availableTimeSlots[formatted] = true;

      finalTimeslots.push({
        name: formatted,
        slots: [],
      });
    }

    //if ((dt.format('m') === 0 || dt.format('m') === 15 || dt.format('m') === 30 || dt.format('m') === 45) &&
    if (dt.format('m') % 5 === 0 && dt.valueOf() >= start && dt.valueOf() <= cutOff) {
      let finalTimeslot = finalTimeslots[finalTimeslots.length - 1];
      finalTimeslot.slots.push(dt.valueOf());
    }
  }

  return finalTimeslots;
};

const buildPayload = (segment, timeFrom) => {
  let time = moment(timeFrom)
    .utc()
    .format();

  return `
        <soap:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
            xmlns:xsd="http://www.w3.org/2001/XMLSchema"
            xmlns:soap="http://schemas.xmlsoap.org/soap/envelope/">
            <soap:Body>
                <GetNextAvailableAppointmentTimes xmlns="http://www.virtualhold.com/Toolkit/Platform-v5">
                    <data>
                        <Tenant>Asurion</Tenant>
                        <Segment>${segment}</Segment>
                        <Options>
                            <NumberOfAppointments>850</NumberOfAppointments>
                            <AppointmentTime>${time}</AppointmentTime>
                        </Options>
                    </data>
                </GetNextAvailableAppointmentTimes>
            </soap:Body>
        </soap:Envelope>
    `;
};

const _fetchNextAppointmentTimeFromVHT = (segment, from) => {
  return new Promise((resolve, reject) => {
    fetch(config.REST_URL(REST_API_NAMES.vhtGetNextAvailableAppointmentTime), {
      method: 'POST',
      body: JSON.stringify({
        body: buildPayload(segment, from),
        storeCode: '',
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        var result = response,
          parser = new DOMParser(),
          xmlDoc = parser.parseFromString(result, 'text/xml'),
          nodes = xmlDoc.getElementsByTagName('Code'),
          code = nodes && nodes.length > 0 ? nodes[0].childNodes[0].nodeValue : 'UNKNOWN';

        if (['107000', '107001'].indexOf(code) > -1) {
          var timeSlots = [],
            availableTimes = xmlDoc.getElementsByTagName('AppointmentTimes')[0].getElementsByTagName('string');

          if (availableTimes && availableTimes.length > 0) {
            for (let i = 0; i < availableTimes.length; i++) {
              timeSlots.push(availableTimes[i].childNodes[0].nodeValue);
            }
            return timeSlots;
          }
        } else {
          throw new Error('Not a valid response code!');
        }
      })
      .then((slots) => {
        resolve(slots);
      })
      .catch((err) => {
        //TODO: need to do a retry!
        reject(err);
      });
  });
};

const generateLocalTimeslots = (from, zoneId) => {
  let addDay = 3,
    timeslots = [];

  let dt = moment()
    .tz(zoneId)
    .hour(0)
    .minute(0)
    .second(0)
    .millisecond(0)
    .add(addDay, 'd');

  timeslots.push(dt.utc().format());

  let currentDt = dt.format('YYYY-MM-DD');

  // LOCAL_NUMBER_OF_DAYS;

  let count = 0;
  while (count <= LOCAL_NUMBER_OF_DAYS) {
    let nextDt = dt.add(5, 'minute');

    if (nextDt.format('YYYY-MM-DD') !== currentDt) {
      count++;
      currentDt = dt.format('YYYY-MM-DD');
    }

    timeslots.push(nextDt.utc().format());
  }

  return timeslots;
};

export default ActionTypes;
export { getAvailableTimeslots };



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/TimePicker/actions/index.js